'use client'

import {useEffect} from 'react'
import {getInjection} from '@runlab/di'
import {ProductListEvents} from '@/src/core/domain/events/product.events'
import {useStore} from '@/src/shared/hooks/useStore'
import {CatalogProductListContent} from '@/src/core/domain/entities/catalog'
import {observer} from 'mobx-react'
import {observable} from 'mobx'
import {PageType} from '@/src/core/domain/entities/page'

const productAnalythicPushed = observable({
  pushed: false,
  setPushed(pushed: boolean) {
    this.pushed = pushed
  },
})

export const ProductSectionAnalyticProvider = observer(({children}: React.PropsWithChildren) => {
  const {pageData} = useStore<CatalogProductListContent>()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (
        pageData &&
        pageData.type === PageType.CatalogProductList &&
        !productAnalythicPushed.pushed
      ) {
        productAnalythicPushed.setPushed(true)
        getInjection('IEventBus').publish(
          ProductListEvents.categoryView({id: pageData.content.section.id}),
        )
      }
    }, 500)

    return () => {
      productAnalythicPushed.setPushed(false)
      clearTimeout(timeoutId)
    }
  }, [pageData])

  return children
})
